import React, { useState, useEffect } from 'react';
import MultiSelect from 'components/common/MultiSelect';
import { Card, Col, Form, Row, Button, Alert } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import { Controller, useFormContext } from 'react-hook-form';
import './style/customStyle.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare } from '@fortawesome/free-regular-svg-icons';
import { getTags } from 'lib/apiService';

const ServiceTag = () => {
  const { control } = useFormContext();
  const [tags, setTags] = useState([]);
  const [addTag, setAddTag] = useState(false);
  const [newTag, setNewTag] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getTags();
        setTags(response?.data?.data);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchData();
  }, []);

  const handleFieldChange = e => {
    setNewTag(e.target.value);
  };

  const handleAddCategory = () => {
    if (newTag) {
      setTags([...tags, newTag]);
      setNewTag('');
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-light">
        Таг
      </Card.Header>
      <Card.Body>
        <Row className="gx-2 gy-3">
          <Col xs="12">
            <Form.Group>
              <Form.Label>Таг сонгох</Form.Label>
              <Controller
                name="tags"
                render={({ field, ref }) => (
                  <MultiSelect
                    {...field}
                    ref={ref}
                    closeMenuOnSelect={false}
                    isMulti
                    options={tags.map(option => ({
                      value: option,
                      label: option
                    }))}
                  />
                )}
                control={control}
              />
            </Form.Group>
          </Col>
          <Col md="12" style={{ textAlign: 'right' }}>
            <Link onClick={() => setAddTag(!addTag)}>
              <h6 className="text-primary">Таг нэмэх</h6>
            </Link>
            {addTag && (
              <div className="d-flex w-100">
                <Form.Group className="w-100 me-2">
                  <Form.Control
                    value={newTag}
                    name="tag"
                    onChange={handleFieldChange}
                    type="text"
                    placeholder="Таг нэмэх"
                  />
                </Form.Group>

                <Button variant="primary" onClick={handleAddCategory}>
                  <FontAwesomeIcon icon={faPlusSquare} />
                </Button>
              </div>
            )}
          </Col>
          <Col md="12">
            <Alert variant={'light'}>
              <p>
                Та мэдээлэл оруулахдаа дараахь{' '}
                <span className="text-success">ТАГ</span> аар тус бүрийн
                категори луу мэдээлэл оруулах боломжтой
              </p>
              <ul>
                <li>
                  Хоол тэжээл, хүнсний аюулгүй байдал ={' '}
                  <Badge bg="info" className="me-2">
                    food-advice
                  </Badge>{' '}
                </li>
                <li>
                  Орчин ба хөдөлмөрийн эрүүл мэнд ={' '}
                  <Badge bg="info" className="me-2">
                    work-advice
                  </Badge>{' '}
                </li>
                <li>
                  Хор судлал, шуурхай удирдлага ={' '}
                  <Badge bg="info" className="me-2">
                    toxilogy-advice
                  </Badge>{' '}
                </li>

                <li>
                  Био технологи, инноваци ={' '}
                  <Badge bg="info" className="me-2">
                    bio-advice
                  </Badge>{' '}
                </li>

                <li>
                  Эрүүл мэндийг дэмжих ={' '}
                  <Badge bg="info" className="me-2">
                    support-advice
                  </Badge>{' '}
                </li>
                <li>
                  Нийгмийн эрүүл мэндийн лавлагаа лаборатори ={' '}
                  <Badge bg="info" className="me-2">
                    laboratory-advice
                  </Badge>{' '}
                </li>

                <li>
                  Нүүр хуудасны зөвлөгөө ={' '}
                  <Badge bg="info" className="me-2">
                    home-advice
                  </Badge>{' '}
                </li>

                <li>
                  Нүүр хуудасны зөвлөгөө ={' '}
                  <Badge bg="info" className="me-2">
                    home-advice
                  </Badge>{' '}
                </li>

                <li>
                  Нүүр хуудасны Кампанит ажил ={' '}
                  <Badge bg="info" className="me-2">
                    home_campaign
                  </Badge>{' '}
                </li>

                <li>
                  Нүүр хуудасны шинэ мэдээлэл ={' '}
                  <Badge bg="info" className="me-2">
                    home_new
                  </Badge>{' '}
                </li>
              </ul>
            </Alert>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ServiceTag;
